import { useQuery } from '@tanstack/react-query'
import type { Item, SellerPortalBrandsResponse } from 'typings'
import { useFetch } from './useFetch'

export function useSellerPortalBrands(searchTerm: string) {
  const { fetcherWrapper } = useFetch()

  const url = new URL(
    `/api/proxy/catalog-seller-portal/brands`,
    window.location.origin
  )

  url.search = new URLSearchParams({
    q: searchTerm,
    from: '1',
    to: '10',
  }).toString()

  async function fetcher() {
    return fetcherWrapper(url.toString())
      .then((r) => r.json())
      .then((r: SellerPortalBrandsResponse) =>
        r.data.map<Item>((item) => ({
          name: item.name.trim(),
          id: item.id,
        }))
      )
  }

  return useQuery({
    queryKey: ['seller-portal-brands', searchTerm],
    queryFn: fetcher,
  })
}
